import dynamic from 'next/dynamic';

import { PageNavigationBlockFragment } from '@hultafors/hultaforsgroup/types';

import styles from './page-navigation-block.module.scss';

const PageNavigation = dynamic(() =>
  import('@hultafors/shared/components').then((mod) => mod.PageNavigationBlock),
);

export interface PageNavigationBlockProps extends PageNavigationBlockFragment {
  activeIndex?: number;
}

export const PageNavigationBlock: React.FC<PageNavigationBlockProps> = ({
  activeIndex: initialActiveIndex,
  id,
  label,
  links,
}) => {
  return (
    <PageNavigation
      activeIndex={initialActiveIndex}
      className={styles['page-navigation']}
      id={id}
      label={label}
      links={links}
    />
  );
};
